//  Modules from the React eco-system
import { useState, useEffect, useContext } from "react"

// Own components
import SubPageNavbar from "../components/navigation/subpage-navbar.component"
import Loader from "../components/loader.component"

// Navigation
import usersMainRoutes from "../routes/mains/users-main.route"
import { Route, Switch, useHistory } from "react-router-dom"

// Redux
import { setPageName } from "../store/pageSlice"
import { useDispatch } from "react-redux"
import { UserContext } from "../store/UserProvider"

// Axios
import axiosClient from "../api/api"

// Interfaces, enums
import { IUser } from "../interfaces/persons"
import { ISubPageRoute } from "../interfaces/pages"
import { ERoles } from "../constants/enum"

function Users() {
    //Logged in user
    const { user } = useContext(UserContext)

    const dispatch = useDispatch()
    const history = useHistory()

    const [users, setUsers] = useState<IUser[]>([])

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        dispatch(setPageName({ pageName: "Users", pageUrl: "/admin/users/main", subPageName: "" }))

        fetchUsers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function fetchUsers() {
        setIsLoading(true)
        try {
            const response = await axiosClient.get("/user")
            setUsers(response.data)
        } catch (error) {
            console.log("Failed to fetch users")
            history.push("/admin/404")
        }
        setIsLoading(false)
    }

    return (
        <div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <SubPageNavbar
                        routes={usersMainRoutes.filter((route: ISubPageRoute) => {
                            return route.permission?.includes(user.role as ERoles)
                        })}
                    />

                    <Switch>
                        {usersMainRoutes
                            .filter((route: ISubPageRoute) => {
                                return route.permission?.includes(user.role as ERoles)
                            })
                            .map((route: ISubPageRoute, key: number) => {
                                return (
                                    <Route
                                        key={key}
                                        path={route.path}
                                        exact
                                        render={() => {
                                            return (
                                                <div>
                                                    <route.component users={users} setUsers={setUsers} {...route.props} />
                                                </div>
                                            )
                                        }}
                                    />
                                )
                            })}
                    </Switch>
                </>
            )}
        </div>
    )
}

export default Users
